import { useContext } from 'react';
import DashboardContext from '../../context/dashboard/DashboardContext';
import Home from './sections/Home';
import { useNavigate, useLocation } from 'react-router-dom';
import MainLayout from '../../Layout/MainLayout';
import ComingSoon from '../ComingSoon/ComingSoon';

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { activeTab, setActiveTab } = useContext(DashboardContext);

  const handleTabChange = (tabId) => {
    const routes = {
      'create-voucher': '/create-voucher',
      'packages': '/packages',
      'notifications': '/notifications',
      'enquiries': '/enquiries',
      'voucher': '/voucher',
      'bookings': '/bookings',
      'feedback': '/feed-back'
    };

    if (routes[tabId]) {
      navigate(routes[tabId]);
    } else {
      if (location.pathname !== '/' && location.pathname !== '/dashboard') {
        navigate('/');
        setTimeout(() => setActiveTab(tabId), 50);
        return;
      }
    }
    setActiveTab(tabId);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'home': return <Home />;
      case 'video-itinerary': return <ComingSoon onBackToDashboard={() => handleTabChange('home')} />;
      default: return <Home />;
    }
  };

  return (
    <MainLayout activeTab={activeTab} setActiveTab={handleTabChange}>
      {renderContent()}
    </MainLayout>
  );
};

export default Dashboard;